import useStore from '../../../../../Hooks/useStore';

const DoubleProductsTab = () => {
  const [getters, setters] = useStore();
  const {
    ticket: { getTicket },
  } = getters;
  const { pinnedProducts, selectedProducts } = getTicket('form.batch');

  return <>produtos</>;
};

export default DoubleProductsTab;
